import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import APIs
import SavedDesignApi from "../../api/customer/design/Saved";

//import UIs
import DesignCard from "../../ui/cards/DesignCard";
import { ErrorNotify } from "../../ui/Toast";

//import skeletons
import DesignCardSkeleton from "../../ui/skeletons/DesignCard";

import { setIsLoading, setMetaData } from "../../redux/reducers/page";
const Saved = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [designs, setDesigns] = React.useState([]);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find Saved designs
  const findDesigns = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const result = await SavedDesignApi(auth.token);

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      return;
    }
    let lastestLoads = [];
    setDesigns(lastestLoads.concat(result.data));

    setIsLoaded(true);
  };

  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت :  ذخیره شده ها",
        description: "میشرت:   ذخیره شده ها",
      })
    );
    dispatch(setIsLoading(false));
    findDesigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-md-7  col-lg-6 col-xl-5  justify-content-center">
      {isLoaded ? (
        designs.map((design, index) => {
          return <DesignCard key={index} design={design} auth={auth} />;
        })
      ) : (
        <DesignCardSkeleton />
      )}
    </div>
  );
};

export default Saved;
